import { render } from "./DashboardWrap.vue?vue&type=template&id=08620c6e"
import script from "./DashboardWrap.vue?vue&type=script&lang=js"
export * from "./DashboardWrap.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__